export default {
	init() {
		// JavaScript to be fired on the home page
		//console.log('Home Init');
        

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		//console.log('Home Finalize');
	},
	resize() {
		//Event set in routes/common.js
		//console.log('route resize');
	}
};



// WEBPACK FOOTER //
// ./scripts/modules/doctors.js